{
  "AddCRMTitle": "CRM-Integration hinzufügen",
  "ModififyCRMTitle": "CRM-Integration ändern",
  "CRMDetailsTitle": "Details",
  "CRMGeneralIDLabel": "AUSWEIS",
  "CRMDetailsIDLabelPlaceholder": "[Automatisch zugewiesen]",
  "CRMDetailsDescriptionLabel": "Beschreibung",
  "CRMValidationDescriptionLabel": "Beschreibung ist erforderlich",
  "NAME": "CRMModal",
  "CRMScopeTitle": "Umfang",
  "CRMConfigurationTitle": "Konfiguration",
  "CRMConfigurationCRMTypeLabel": "CRM",
  "CRMConfigurationTypeNone": "Keiner",
  "CRMConfigurationTab_Setting_Name": "Einstellungsname",
  "CRMConfigurationTab_Value": "Wert"
}